import { __awaiter, __decorate, __extends, __generator } from "tslib";
/* eslint-disable */
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ResultApi, UserScenarioApi } from '../apis';
import { MessageApi } from "@/apis/line";
import RadarChart from "@/components/RadarChart.vue";
var resultApi = new ResultApi(undefined);
var messageApi = new MessageApi(undefined);
var userScenarioApi = new UserScenarioApi(undefined);
var EndPage = /** @class */ (function (_super) {
    __extends(EndPage, _super);
    function EndPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.survey = null;
        _this.result = null;
        _this.line = {
            name: '---',
            pictureUrl: ''
        };
        _this.message = {
            context: ''
        };
        _this.hasChart = false;
        return _this;
    }
    EndPage.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var entry, _a, _loop_1, this_1, i, targetUserID, request;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.survey = this.$store.state.survey;
                        entry = this.$store.state.entry;
                        _a = this;
                        return [4 /*yield*/, resultApi.getResult(this.$store.state.resultID).then(function (res) { return res.data; })];
                    case 1:
                        _a.result = _b.sent();
                        if (!this.survey) {
                            alert("survey not found");
                            return [2 /*return*/];
                        }
                        if (!entry) {
                            alert("entry not found");
                            return [2 /*return*/];
                        }
                        if (!this.result) {
                            return [2 /*return*/];
                        }
                        if (this.result.chartData) {
                            this.hasChart = true;
                            if (this.survey.chartLabels && this.result.chartData.labels && this.result.chartData.values) {
                                this.labelArray = [];
                                this.valueArray = [];
                                _loop_1 = function (i) {
                                    var label = this_1.survey.chartLabels[i];
                                    var labelIndex = this_1.result.chartData.labels.findIndex(function (l) { return l.startsWith(label); });
                                    this_1.labelArray.push(this_1.result.chartData.labels[labelIndex]);
                                    this_1.valueArray.push(this_1.result.chartData.values[labelIndex]);
                                };
                                this_1 = this;
                                for (i = 0; i < this.survey.chartLabels.length; i++) {
                                    _loop_1(i);
                                }
                            }
                            else {
                                this.labelArray = this.result.chartData.labels;
                                this.valueArray = this.result.chartData.values;
                            }
                            if (this.result.commentDatas) {
                                this.result.commentDatas = this.result.commentDatas.map(function (commentData) {
                                    if (commentData && commentData.content) {
                                        commentData.content = commentData.content.replaceAll('\n', '<br>');
                                    }
                                    return commentData;
                                });
                            }
                        }
                        targetUserID = String(entry.targetUserID);
                        request = {
                            tenant_id: this.survey.tenantID,
                            survey_id: this.survey.id,
                            result_id: this.result.id
                        };
                        return [4 /*yield*/, messageApi.sendResult(targetUserID, request).then(function (res) { return res.data; })];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(EndPage.prototype, "chartData", {
        get: function () {
            return {
                // データセットプロパティに関する設定
                // See https://misc.0o0o.org/chartjs-doc-ja/charts/radar.html
                // labels: ["マインド", "アクション", "コミュニケーション", "パフォーマンス", "スペック"],
                labels: this.labelArray ? this.labelArray : [],
                datasets: [
                    {
                        label: "得点",
                        data: this.valueArray ? this.valueArray : [],
                        backgroundColor: 'rgba(255, 193, 205, 0.2)',
                        borderColor: '#FF4F6F'
                    }
                ]
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EndPage.prototype, "chartOptions", {
        get: function () {
            return {
                responsive: true,
                responsiveAnimationDuration: 0,
                maintainAspectRatio: false,
                // onResize(chart, size): void {
                //   // サイズ変更が発生したときに呼び出されます。チャートインスタンスと新しいサイズの2つの引数を渡します。
                // },
                layout: {
                    // レイアウトに関する設定
                    // See https://misc.0o0o.org/chartjs-doc-ja/configuration/layout.html
                    padding: 0 // グラフの内側に追加するパディング
                },
                title: {
                    // タイトル
                    // See https://misc.0o0o.org/chartjs-doc-ja/configuration/title.html
                    display: false,
                    position: "top",
                    fontSize: 12,
                    padding: 10,
                    text: ""
                },
                legend: {
                    // 凡例に関する設定
                    // See https://misc.0o0o.org/chartjs-doc-ja/configuration/legend.html
                    display: false,
                    position: "bottom" // 凡例の位置
                },
                tooltips: {
                    // ツールチップに関する設定
                    // See https://misc.0o0o.org/chartjs-doc-ja/configuration/tooltip.html
                    display: true // キャンバス上でツールチップを有効にします
                },
                elements: {
                    // 要素に関する設定
                    // See https://misc.0o0o.org/chartjs-doc-ja/configuration/elements.html
                    point: {
                    // 点に関する設定
                    },
                    line: {
                    // 線に関する設定
                    },
                    rectangle: {
                    // 矩形に関する設定
                    },
                    arc: {
                    // 円弧に関する設定
                    }
                },
                scale: {
                    angleLines: {
                        display: false
                    },
                    ticks: {
                        suggestedMin: -5,
                        suggestedMax: 5,
                        stepSize: 2
                    }
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: String, required: true })
    ], EndPage.prototype, "liffId", void 0);
    EndPage = __decorate([
        Component({
            components: { RadarChart: RadarChart }
        })
    ], EndPage);
    return EndPage;
}(Vue));
export default EndPage;
